import CodeSwitcher from "../../../../src/components/code-switcher";
import * as React from 'react';
export default {
  CodeSwitcher,
  React
};